import { render, staticRenderFns } from "./customerAnalysis.vue?vue&type=template&id=2352fb54&scoped=true&"
import script from "./customerAnalysis.vue?vue&type=script&lang=js&"
export * from "./customerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./customerAnalysis.vue?vue&type=style&index=0&id=2352fb54&prod&lang=scss&"
import style1 from "./customerAnalysis.vue?vue&type=style&index=1&id=2352fb54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2352fb54",
  null
  
)

export default component.exports